var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entity-page"},[_c('entity-view',{attrs:{"id":_vm.id,"type":_vm.type},on:{"goBack":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }